<template>
  <div id="app">
    <error-message></error-message>
    <sync-config></sync-config>
    <extension-version-checker version="2.6.0"></extension-version-checker>
    <router-view></router-view>
    <dialogs-wrapper wrapper-name="default" />
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { addBeforeUnload, removeBeforeUnload } from '@/lib/before-unload'
  import SyncConfig from '@/components/sync-config/sync-config'
  import ErrorMessage from '@/components/error-message-modal/error-message-modal'
  import ExtensionVersionChecker from '@/components/extension-version-checker/extension-version-checker'

  const { mapActions: mapGlobalActions } = createNamespacedHelpers('global')

  export default {
    components: {
      ErrorMessage,
      SyncConfig,
      ExtensionVersionChecker
    },
    created () {
      this.$router.beforeEach((to, from, next) => {
        this.activeCallPresent(to.path)
          ? addBeforeUnload('CALL_PROTECTION', 'Are you sure you wish to leave the call?')
          : removeBeforeUnload('CALL_PROTECTION')
        next()
      })

      this.retrieveOngoingActivitiesPeriodically()
    },
    methods: {
      ...mapGlobalActions([
        'retrieveOngoingActivities'
      ]),
      retrieveOngoingActivitiesPeriodically () {
        this.retrieveOngoingActivities()
        setInterval(this.retrieveOngoingActivities, 60000)
      },
      activeCallPresent (path) {
        return [
          '/phone-controller',
          '/rep-call',
          '/live-coach-call'
        ].includes(path)
      }
    }
  }
</script>

<style src="sanitize.css"></style>
<style src="font-awesome/css/font-awesome.css"></style>
<style lang="less" src="./app.less"></style>



// WEBPACK FOOTER //
// app.vue?ea90117c